/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { BASE_PATH } from '@myprofile-ui/pidx-utils'

@Injectable({
  providedIn: 'root',
})
export class DateOfBirthService {
  private httpClient = inject(HttpClient)
  private basePath = inject(BASE_PATH)

  public getDateOfBirthForProfile(country: string, language: string, header?: HttpHeaders): Observable<DateOfBirthDto> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.get<DateOfBirthDto>(`${this.basePath}/date-of-birth?country=${country}`, { headers: headers })
  }

  public setDateOfBirthForProfile(
    country: string,
    language: string,
    dateOfBirth: DateOfBirthDto,
    header?: HttpHeaders,
  ): Observable<DateOfBirthDto> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.post<DateOfBirthDto>(`${this.basePath}/date-of-birth?country=${country}`, dateOfBirth, {
      headers: headers,
    })
  }

  public deleteDateOfBirthForProfile(country: string, language: string, header?: HttpHeaders): Observable<void> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.delete<void>(`${this.basePath}/date-of-birth?country=${country}`, { headers: headers })
  }

  public updateDateOfBirthForProfile(
    country: string,
    language: string,
    dateOfBirth: DateOfBirthDto,
    header?: HttpHeaders,
  ): Observable<DateOfBirthDto> {
    const headers = header ? header.set('accept-language', language) : new HttpHeaders({ 'accept-language': language })
    return this.httpClient.patch<DateOfBirthDto>(`${this.basePath}/date-of-birth?country=${country}`, dateOfBirth, {
      headers: headers,
    })
  }
}

export interface DateOfBirthDto {
  dateOfBirth?: string
}
